import { differenceInMinutes } from 'date-fns';

const tokenIsExpired = (token: { expires: string }): boolean =>
    differenceInMinutes(new Date(token.expires), new Date()) < 5;

export { tokenIsExpired };
